/*
 * @Author: Json Chen
 * @Date: 2021-06-08 14:17:49
 * @LastEditTime: 2021-06-30 18:01:34
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/components/Configuration/Configuration.tsx
 */
import React, { memo } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import Link from '@/src/components/Link/Link';
import css from './Configuration.less';
import { getI18nFromGeneral } from '@/src/tools/tools';
interface IProps {
  configStart?: string;
  configEnd?: string;
  configLink?: string;
  linkTo?: string;
  hideGt?: boolean;
  hideRarePart?: boolean;
  href?: string;
  hasIcon?: boolean;
}
const Configuration = (props: IProps) => {
  const {
    configStart,
    configEnd,
    configLink,
    linkTo,
    hideGt,
    hideRarePart,
    href,
    hasIcon = true,
  } = props;
  return (
    <div className={css.container}>
      {hasIcon && (
        <div className={css.icon}>
          <InfoCircleOutlined />
        </div>
      )}
      <div>
        {configStart || getI18nFromGeneral('general.configuration.start')}
        {!hideRarePart && (
          <React.Fragment>
            {!hideGt ? ` > ` : ' '}
            {href ? (
              <a href={href} target='_blank' className={css.tagsRightPart}>
                {configLink ?? getI18nFromGeneral('general.configuration.link')}
              </a>
            ) : (
              <Link to={linkTo || '/'} className={css.tagsRightPart}>
                {configLink ?? getI18nFromGeneral('general.configuration.link')}
              </Link>
            )}
            {configEnd || getI18nFromGeneral('general.configuration.end')}
          </React.Fragment>
        )}
      </div>
    </div>
  );
};
export default memo(Configuration);
